import { z } from "zod";
import { ConnectionProvider } from "@common/types/integrationConnection";

export const integrationCoaMappingSchema = z.object({
    id: z.string().uuid(),
    entityId: z.number().int(),
    provider: z.nativeEnum(ConnectionProvider),
    transactionType: z.string(),
    /** User-facing name of the transaction type. */
    label: z.string(),
    /** Null while the user has not yet mapped the type to an account. */
    accountId: z.string().uuid().nullable(),
});

export type IntegrationCoaMapping = z.infer<typeof integrationCoaMappingSchema>;

export const integrationCoaMappingsResponseSchema = z.object({
    mappings: z.array(integrationCoaMappingSchema),
});

export type IntegrationCoaMappingsResponse = z.infer<
    typeof integrationCoaMappingsResponseSchema
>;

export const updateIntegrationCoaMappingBodySchema = z.object({
    accountId: z.string().uuid().nullable(),
});

export type UpdateIntegrationCoaMappingBody = z.infer<
    typeof updateIntegrationCoaMappingBodySchema
>;
